/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskForm990JSON } from './ExecRiskForm990JSON';
import {
    ExecRiskForm990JSONFromJSON,
    ExecRiskForm990JSONFromJSONTyped,
    ExecRiskForm990JSONToJSON,
} from './ExecRiskForm990JSON';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedForm990JSONResponse
 */
export interface ExecRiskPaginatedForm990JSONResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm990JSONResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskForm990JSON>}
     * @memberof ExecRiskPaginatedForm990JSONResponse
     */
    results: Array<ExecRiskForm990JSON>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedForm990JSONResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm990JSONResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm990JSONResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedForm990JSONResponse interface.
 */
export function instanceOfExecRiskPaginatedForm990JSONResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedForm990JSONResponseFromJSON(json: any): ExecRiskPaginatedForm990JSONResponse {
    return ExecRiskPaginatedForm990JSONResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedForm990JSONResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedForm990JSONResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskForm990JSONFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedForm990JSONResponseToJSON(value?: ExecRiskPaginatedForm990JSONResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskForm990JSONToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

